import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { mdiQrcode } from '@mdi/js'
import { AppIcon } from '../ui/icon'
import { Button } from '../ui/button'
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../ui/dialog'
import { AssetLabelsCard } from './AssetLabelsCard'

/**
 * AssetLabelsButton puts the QR sticker in the asset header rather than behind a
 * tab of its own.
 *
 * A tab implied there was something to browse; there is one code and two
 * actions. As a header icon it sits with the other things you do TO an asset —
 * view it in the graph, archive it — which is what printing its label is.
 */
export function AssetLabelsButton({ org, assetUid }: { org: string; assetUid: string }) {
    const { t } = useTranslation('labels')
    const [open, setOpen] = useState(false)

    return (
        <>
            <Button
                size="icon"
                variant="outline"
                aria-label={t('card.title')}
                title={t('card.title')}
                onClick={() => setOpen(true)}
                data-testid="asset-labels-btn"
            >
                <AppIcon path={mdiQrcode} size="sm" />
            </Button>

            <Dialog open={open} onOpenChange={setOpen}>
                <DialogContent className="sm:max-w-2xl" data-testid="asset-labels-dialog">
                    <DialogHeader>
                        <DialogTitle>{t('card.title')}</DialogTitle>
                        <DialogDescription>{t('card.description')}</DialogDescription>
                    </DialogHeader>
                    <AssetLabelsCard org={org} assetUid={assetUid} showHeading={false} />
                </DialogContent>
            </Dialog>
        </>
    )
}
